import { datadogRum } from '@datadog/browser-rum';
import type {
  Observability,
  ObservableAction,
  ObservableActionContext,
} from './observability';

const { addAction } = datadogRum;

export const observe: Observability = {
  action: (
    name: ObservableAction,
    context?: ObservableActionContext | undefined,
  ): void => addAction(name, context),
};
